export const initialMonth = () => new Date().getMonth() + 1;

export const initialYear = () => new Date().getFullYear();

export const compareUserInformation = (currentPhone, currentEmail, phone, email) =>
  currentPhone !== phone || (email && email !== currentEmail);
